import React from 'react'
import { Form, Input, Radio } from 'antd' // Import AntD form components
import './ChooseFeatures.css'
import ButtonBlack from 'components/design/Form/ButtonBlack/index'
import { useDispatch } from 'react-redux'

const StepChooseFeatures = ({ nextStep, selectedFeatures, setSelectedFeatures, form }) => {
  const dispatch = useDispatch()
  const isBYOAOnly = selectedFeatures === 'byo-agent'
  const toggleSelect = key => {
    setSelectedFeatures(key)

    form.setFieldsValue({ features: key })
  }

  const handleContinue = async () => {
    try {
      await form.validateFields(['features']) //  validates using AntD rules
      // Persist selection so later steps/modals can route dynamically
      dispatch({
        type: 'settings/CHANGE_SETTING',
        payload: { setting: 'selectedFeaturesForGetStarted', value: selectedFeatures },
      })
      if (isBYOAOnly) {
        form.submit()
      } else {
        nextStep()
      }
    } catch (error) {
      // AntD will show error message automatically
      console.log('Validation failed:', error)
    }
  }

  const features = [
    {
      key: 'chat',
      icon: (
        <div style={{ background: '#EFF8FF', padding: '10px', borderRadius: '8px' }}>
          <div className="featuresIcon chatFeature" />
        </div>
      ),
      title: 'Chat & Messaging',
      description: 'Real-time user to user & group chats.',
    },
    {
      key: 'calling',
      icon: (
        <div style={{ background: '#ECFDF3', padding: '10px', borderRadius: '8px' }}>
          <div className="featuresIcon callingFeature" />
        </div>
      ),
      title: 'Voice & Video Calling',
      description: 'In-app calling & conferencing.',
    },
    {
      key: 'aiAgent',
      icon: (
        <div style={{ background: '#F4F3FF', padding: '10px', borderRadius: '8px' }}>
          <div className="featuresIcon aiAgentFeature" />
        </div>
      ),
      title: 'AI Agent',
      description: 'Full stack AI Agents for your app.',
    },
    {
      key: 'byo-agent',
      icon: (
        <div style={{ background: '#FEF0C7', padding: '10px', borderRadius: '8px' }}>
          <div className="featuresIcon moderationFeature" />
        </div>
      ),
      title: 'Bring Your Own Agent',
      description: 'Integrate an existing AI agent.',
    },
  ]

  return (
    <div className="chooseFeatureWrapper">
      <div className="chooseFeature">
        <div className="chooseFeatureHeader">
          <div className="chooseFeatureTitle">Select Your Product</div>
          <div className="chooseFeatureSubtitle">
            Choose the product you would like to begin with. Additional products can be integrated
            at any time.
          </div>
        </div>

        <div className="featuresContainer">
          {features.map((f, idx) => {
            const isSelected = selectedFeatures === f.key
            return (
              <React.Fragment key={f.key}>
                {idx === 0 && (
                  <div className="feature-group-label">Real-Time User Communication</div>
                )}
                {idx === 2 && <div className="feature-group-label" style={{marginTop: '10px'}}>AI Agent Platform</div>}
                <div
                  className={`feature-card ${isSelected ? 'selected' : ''}`}
                  role="button"
                  tabIndex={0}
                  onClick={() => toggleSelect(f.key)}
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault()
                      toggleSelect(f.key)
                    }
                  }}
                  aria-pressed={isSelected}
                >
                  <div className="feature-left">
                    {f.icon}
                    <div>
                      <div className="feature-title">{f.title}</div>
                      <div className="feature-description">{f.description}</div>
                    </div>
                  </div>
                  <Radio checked={isSelected} />
                </div>
              </React.Fragment>
            )
          })}
        </div>
        <Form.Item
          name="features"
          rules={[{ required: true, message: 'Please select a product to continue' }]}
          initialValue={selectedFeatures}
          style={{ margin: '0px' }}
        >
          <Input type="hidden" style={{ minHeight: '0px', border: '2px solid green' }} />
        </Form.Item>

        <ButtonBlack
          buttonStyles={{
            width: '100%',
            height: '44px',
            marginTop: '5px',
            fontSize: '16px',
          }}
          holderStyles={{ width: '100%' }}
          buttonText="Continue"
          htmlType="button"
          onClick={handleContinue}
        />
      </div>
    </div>
  )
}

export default StepChooseFeatures
